import { REFUND_ROUTES, REFUND_ROUTES_MAP } from '../model/constants';

interface RefundSkipStepsOptions {
	skipPassengers: boolean;
	skipReasons: boolean;
	skipDocuments: boolean;
}

export const getRefundPrevPath = (
	currentPath: string,
	{ skipPassengers, skipReasons, skipDocuments }: RefundSkipStepsOptions
): string | null => {
	const prevPath = REFUND_ROUTES_MAP.get(currentPath)?.prev ?? null;

	if (!prevPath) {
		return null;
	}

	if (currentPath === REFUND_ROUTES.REQUEST) {
		return null;
	}

	if (prevPath === REFUND_ROUTES.PASSENGERS && skipPassengers) {
		return null;
	}

	if (prevPath === REFUND_ROUTES.REASONS && skipReasons) {
		return skipPassengers ? null : REFUND_ROUTES.PASSENGERS;
	}

	if (prevPath === REFUND_ROUTES.DOCUMENTS && skipDocuments) {
		if (skipReasons) {
			return skipPassengers ? null : REFUND_ROUTES.PASSENGERS;
		}

		return REFUND_ROUTES.REASONS;
	}

	return prevPath;
};
